import { render, staticRenderFns } from "./EventCreateView.vue?vue&type=template&id=72afc8d1&scoped=true&"
import script from "./EventCreateView.vue?vue&type=script&lang=ts&"
export * from "./EventCreateView.vue?vue&type=script&lang=ts&"
import style0 from "./EventCreateView.vue?vue&type=style&index=0&id=72afc8d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72afc8d1",
  null
  
)

export default component.exports